module.exports = __webpack_public_path__ + "static/sport/img-title.3fe249a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sinh/img-title.png
// module id = 8IFD
// module chunks = 0